// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"16de6576","592":"9875bc00","844":"e9d9ec93"}[chunkId] + ".chunk.js";
};